import { render } from "./RoleDetails.vue?vue&type=template&id=5e8759f6&scoped=true"
import script from "./RoleDetails.vue?vue&type=script&lang=js"
export * from "./RoleDetails.vue?vue&type=script&lang=js"

import "./RoleDetails.vue?vue&type=style&index=0&id=5e8759f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8759f6"]])

export default __exports__